/* tslint:disable */
/* eslint-disable */
export enum OpkraevningScopeEnum {
  Customer = 'Customer',
  Partner = 'Partner'
}
